import { useRef } from 'react'
import type ReactECharts from 'echarts-for-react'
import { RiskProfileCard } from '../../RiskProfileCard'
import { ChartQueryState } from '../../ChartQueryState'
import { ChartExportActions } from '../../../chart/ChartExportActions'
import { useExportXlsx } from '../../../hooks/useExportXlsx'
import { useExportChartImage } from '../../../hooks/useExportChartImage'
import RiskByHazardsChart from '../../../chart/RiskByHazards.chart'
import type { RiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'
import { useProfileHazardTypeData } from '../../../hooks/useProfileHazardTypeData'

export interface RiskByHazardWidgetProps {
  queryParams: RiskProfileQueryParams | null
  metricOption: RiskProfileMetricOption
}

export function RiskByHazardWidget({ queryParams, metricOption }: RiskByHazardWidgetProps) {
  const { request, query } = useProfileHazardTypeData(queryParams)
  const { exportXlsx, isExporting } = useExportXlsx(request)
  const chartRef = useRef<ReactECharts>(null)
  const handleExportImage = useExportChartImage(chartRef, 'risk-by-hazard')

  return (
    <RiskProfileCard
      title="Risk by hazard"
      description="Ranked exposure by hazard for the selected assets and metric."
      onExport={
        <ChartExportActions
          onExportXlsx={exportXlsx}
          onExportImage={handleExportImage}
          isExportingXlsx={isExporting}
          xlsxDisabled={!request}
        />
      }
      className="min-h-96"
    >
      <ChartQueryState query={query}>
        {(data) => <RiskByHazardsChart ref={chartRef} data={data} metricOption={metricOption} />}
      </ChartQueryState>
    </RiskProfileCard>
  )
}
